
$(document).ready(function () {

   function size_wrror_message(rebuy_cart){
      if (rebuy_cart.item_count > 0) {
    
          var items = rebuy_cart.items;var groupedByProduct = {};

          items.forEach(item => {
            var productId = item.product_id;

            var sizeOption = item.options_with_values?.find(opt => opt.name === "SIZE")?.value;

            if (!groupedByProduct[productId]) {
              groupedByProduct[productId] = new Set();
            }

            groupedByProduct[productId].add(sizeOption);
          });

          console.log(groupedByProduct, " sss");

          var productsWithMultipleSizes = Object.entries(groupedByProduct)
            .filter(([_, sizes]) => sizes.size > 1)
            .map(([productId, sizes]) => ({
              productId,
              sizes: Array.from(sizes),
            }));

          console.log(productsWithMultipleSizes);

          (function tryInsertOrRemoveMessage(attempt = 0) {
            var MAX_ATTEMPTS = 100;
            var container = document.querySelector('.rebuy-cart__flyout-body');

            if (!container) {
              if (attempt < MAX_ATTEMPTS) {
                requestAnimationFrame(() => tryInsertOrRemoveMessage(attempt + 1));
              }
              return;
            }

            var existingMsg = container.querySelector('.custom-sizing-message');

            if (productsWithMultipleSizes.length > 0) {
              if (!existingMsg) {
                var messageDiv = document.createElement('div');
                messageDiv.className = 'custom-sizing-message';
                messageDiv.style.padding = '16px';
                messageDiv.style.backgroundColor = '#f9f9f9';
                messageDiv.style.fontSize = '14px';
                messageDiv.style.lineHeight = '1.4';
                messageDiv.style.marginBottom = '12px';

                messageDiv.innerHTML = "<p><strong>Hey there! </strong>We noticed you have 2 different sizes of the same style in your cart. Use our size selector tool (located on the product page) to confidently select your correct size. </p><p>We offer a <em>FREE EXCHANGE</em><strong> </strong>to help you get it right!</p>";

                container.insertBefore(messageDiv, container.firstChild);
              }
            } else {
              if (existingMsg) {
                existingMsg.remove();
              }
            }
          })();
        }
    }

    document.addEventListener('rebuy:smartcart.init', (event) => {
      var smartcart = event.detail.smartcart;
      if(smartcart.cart != null) {
        size_wrror_message(smartcart.cart);
      }
    });
    document.addEventListener('rebuy:smartcart.show', (event) => {
      var smartcart = event.detail.smartcart;
      if(smartcart.cart != null) {
        size_wrror_message(smartcart.cart);
      }
    });
    document.addEventListener('rebuy:cart.change', (event) => { 
      console.log('rebuy:cart.change event', event.detail); 
      var smartcart = event.detail.cart;
      if(smartcart.cart != null) {
        size_wrror_message(smartcart.cart);
      }
    });

    // LTQ custom colors_by_pricing
    const colors_by_pricing = $('.colors_by_pricing');   
    if(colors_by_pricing.length > 0){
      colors_by_pricing.each(function(index, element){
        var currentPrice = $(this).data('price');
        if(index > 0){
          console.log('index > 0');
         var prevPrice = colors_by_pricing[index - 1].getAttribute('data-price');
          if(currentPrice != prevPrice){
            $(this).show();
          }else{
            $(this).hide();
          }
        }else{
          $(this).show();
        }
      });
    }

    // LTQ custom check Not restocked
   const variant_id = $('input[name="id"]').val();
   console.log(variant_id);
   const check_back_in_stock = $('.list-variants .variant-item-'+variant_id).data('back-in-stock');
   const check_back_in_stock_inventory = $('.list-variants .variant-item-'+variant_id).data('inventory-quantity');
   console.log('check_back_in_stock---'+check_back_in_stock);
    if((check_back_in_stock || check_back_in_stock == 'true') && check_back_in_stock_inventory <= 0){
      $('.swym-wishlist-button-bar').show();
      $('.buy-buttons button[type="submit"]').hide();
    }else{
      $('.swym-wishlist-button-bar').hide();
      $('.buy-buttons button[type="submit"]').show();
      /*
      const check_available = $('.list-variants .variant-item-'+variant_id).data('available');
      console.log(check_available);
      if(check_available || check_available == 'true'){
        $('.swym-wishlist-button-bar').hide();
        $('.buy-buttons button[type="submit"]').show();
      }else{
        $('.swym-wishlist-button-bar').show();
        $('.buy-buttons button[type="submit"]').hide();
      }
      */
    }

});